$(document).ready(function(){
   console.log('ML');

   // Scrolled Items
   function handleScroll() {
      let $window = $(this);
      let scrollHeight = $window.scrollTop();
      let windowWidth = $(window).width();
      let $elements = $(".site-header");

      let $elementsNoClassBelow1200 = $(".menu-item a");

      $elements.toggleClass('scrolled', scrollHeight > $elements.first().height());

      if (windowWidth < 1200) {
         $elementsNoClassBelow1200.removeClass('scrolled');
      }
   }

   $(document).scroll(handleScroll);
   handleScroll();

   //  Show/hide sub-category
   $(".category__toggle").on("click", function () {
      const subCategory = $(this).parent().next(".sub-category");

      subCategory.stop(true, true).slideToggle(0, function () {

         const isVisible = subCategory.is(":visible");
         $(this).prev().find(".category__toggle").text(isVisible ? "−" : "+");
      });
   });

   // Show/hide filters
   const $toggleButton = $('.products-filters__toggle');
   const $filterItems = $('.products-filters__items');

   if ($toggleButton.length && $filterItems.length) {
      $toggleButton.on('click', function () {
         const isCollapsed = $filterItems.toggleClass('collapsed').hasClass('collapsed');
         $toggleButton.text(isCollapsed ? '+' : '−');
         $toggleButton.attr('aria-expanded', !isCollapsed);
      });
      const checkWindowSize = function() {
         if ($(window).width() > 850) {
            $filterItems.removeClass('collapsed');
            $toggleButton.attr('aria-expanded', true).text('−');
         } else {
            $filterItems.addClass('collapsed');
            $toggleButton.attr('aria-expanded', false).text('+');
         }
      }

      $(window).on('resize', checkWindowSize);
      checkWindowSize();
   }
});

// Woo
$(document).ready(function () {
   const filtersState = {
      arrayTerm: [],
      sortOption: null,
   };

   const urlParams = new URLSearchParams(window.location.search);
   const isEnglish = window.location.pathname.includes('/en/');
   const basePath = isEnglish ? '/en/wyroby/' : '/wyroby/';
   const ajaxUrl = `${window.location.origin}/wp-admin/admin-ajax.php`;

   // Inicjalizacja filtrów
   initializeFilters();

   // Obsługa filtrów
   $('.product-filters__checkbox input').on('change', handleFilterChange);
   $('#sort-options').on('change', handleSortChange);
   $('.category__link, .sub-category__link').on('click', handleCategoryClick);

   generateCategoryLinks();

   // Funkcja inicjalizująca
   function initializeFilters() {
      const categorySlug = urlParams.get('category_slug');
      const categoryTerm = urlParams.get('category_term');
      const sort = urlParams.get('sort');

      if (categorySlug && categoryTerm) {
         filtersState.arrayTerm.push({ term: categoryTerm, slug: categorySlug });
         filtersState.sortOption = sort;
         fetchProductsAndCategoryData(categorySlug, categoryTerm);
      } else if ($('body').hasClass('page-id-63') || $('body').hasClass('page-id-543')) {
         fetchProducts();
      }
   }

   // Obsługa zmiany filtrów
   function handleFilterChange() {
      const $checkbox = $(this);
      const termData = {
         term: $checkbox.data('term'),
         slug: $checkbox.data('slug'),
      };

      if ($checkbox.is(':checked')) {
         filtersState.arrayTerm.push(termData);
      } else {
         filtersState.arrayTerm = filtersState.arrayTerm.filter(item => item.term !== termData.term);
      }

      applyFilters();
   }

   // Obsługa zmiany sortowania
   function handleSortChange() {
      filtersState.sortOption = $(this).val();
      applyFilters();
   }

   // Obsługa kliknięcia w kategorię
   function handleCategoryClick(e) {
      e.preventDefault();

      const $link = $(this);
      const slug = $link.data('slug');
      const term = $link.data('term');

      $('.category__link, .sub-category__link').removeClass('active');
      $link.addClass('active');

      fetchProductsAndCategoryData(slug, term);
   }

   // Generowanie linków kategorii
   function generateCategoryLinks() {
      $('.category__link, .sub-category__link').each(function () {
         const slug = $(this).data('slug');
         const term = $(this).data('term');
         let categoryLink = `${window.location.origin}${basePath}?category_slug=${slug}&category_term=${term}`;

         if (filtersState.sortOption) {
            categoryLink += `&sort=${filtersState.sortOption}`;
         }

         filtersState.arrayTerm.forEach(filter => {
            categoryLink += `&filter_term[]=${filter.term}&filter_slug[]=${filter.slug}`;
         });

         $(this).attr('href', categoryLink);
      });
   }

   // Zastosowanie filtrów
   function applyFilters() {
      const categorySlug = $('.category__link.active').data('slug') || null;
      fetchProducts(categorySlug);
   }

   // Pobranie produktów i danych kategorii
   function fetchProductsAndCategoryData(slug, term) {
      showLoader();

      fetchProducts(slug);
      fetchCategoryData(slug, term);
   }

   // Pobranie produktów
   function fetchProducts(categorySlug = null) {
      showLoader();

      $.ajax({
         type: 'POST',
         url: ajaxUrl,
         dataType: 'json',
         data: {
            action: 'filter_projects',
            categorySlug,
            arrayTerm: filtersState.arrayTerm,
            sort: filtersState.sortOption,
         },
         success: updateProducts,
         error: handleAjaxError,
      });
   }

   // Pobranie danych kategorii
   function fetchCategoryData(slug, term) {
      $.ajax({
         type: 'POST',
         url: ajaxUrl,
         dataType: 'json',
         data: {
            action: 'get_category_content',
            slug,
            term,
         },
         success: updateCategoryData,
         error: handleAjaxError,
      });
   }

   // Aktualizacja produktów
   function updateProducts(res) {
      $('.products-output').html(res.html);
      $('.product-counter__value').text(res.product_count);
      hideLoader();
   }

   // Aktualizacja danych kategorii
   function updateCategoryData(response) {
      if (response.success) {
         $('.about-products__header').text(response.data.title);
         $('.about-products__description').html(response.data.description);
      }
      hideLoader();
   }

   // Obsługa błędów AJAX
   function handleAjaxError() {
      console.error('Błąd podczas pobierania danych');
      hideLoader();
   }

   // Pokazanie loadera
   function showLoader() {
      $('.products-output').html('<div class="loader"></div>');
   }

   // Ukrycie loadera
   function hideLoader() {
      $('.loader').remove();
   }
});






